import axios from "axios";
import { configureStore } from "..";
import { setRefreshedTokenData } from "../store/auth";
import { refresh_token } from "./auth";

const baseURL = process.env.REACT_APP_BASE_URL;
export { baseURL };

const studentBaseURL = process.env.REACT_APP_STUDENT_BASE_URL;
export { studentBaseURL };

const staffBaseURL = process.env.REACT_APP_STAFF_BASE_URL;
export { staffBaseURL };

const courseBaseURL = process.env.REACT_APP_COURCE_BASE_URL;
export { courseBaseURL };

const semesterBaseURL = process.env.REACT_APP_SEMESTER_BASE_URL;
export { semesterBaseURL };

const subjectBaseURL = process.env.REACT_APP_SUBJECT_BASE_URL;
export { subjectBaseURL };

const circularBaseURL = process.env.REACT_APP_CIRCULAR_BASE_URL;
export { circularBaseURL };

const dashboardBaseURL = process.env.REACT_APP_DASHBOARD_BASE_URL;

const attendanceBaseURL = process.env.REACT_APP_ATTENDANCE_BASE_URL;

const lendBaseURL = process.env.REACT_APP_LEND_BASE_URL;
export { lendBaseURL };

const arrivalBaseURL = process.env.REACT_APP_ARRIVAL_BASE_URL;
export { arrivalBaseURL };

const examAndGradeBaseURL = process.env.REACT_APP_EXAM_AND_GRADE;

const staffAttendanceBaseURL = process.env.REACT_APP_STAFF_ATTENDANCE_URL;

const classesBaseURL = process.env.REACT_APP_CLASSES_BASE_URL;

const institutionBaseURL = process.env.REACT_APP_INSTITUTION_BASE_URL;

const client = axios.create({
  baseURL: baseURL,
});

const student = axios.create({
  baseURL: studentBaseURL,
});

const course = axios.create({
  baseURL: courseBaseURL,
});

const semester = axios.create({
  baseURL: semesterBaseURL,
});

const subject = axios.create({
  baseURL: subjectBaseURL,
});

const circular = axios.create({
  baseURL: circularBaseURL,
});

const dashboard = axios.create({
  baseURL: dashboardBaseURL,
});

const attendance = axios.create({
  baseURL: attendanceBaseURL,
});

const lend = axios.create({
  baseURL: lendBaseURL,
});

const arrival = axios.create({
  baseURL: arrivalBaseURL,
});

const staff = axios.create({
  baseURL: staffBaseURL,
});

const examAndGrade = axios.create({
  baseURL: examAndGradeBaseURL,
});

const staffAttendance = axios.create({
  baseURL: staffAttendanceBaseURL,
});

const classes = axios.create({
  baseURL: classesBaseURL,
});

const institution = axios.create({
  baseURL: institutionBaseURL,
});
student.interceptors.response.use(
  async (response) => {
    const originalRequest = response.config;

    if (response.data.statusCodeValue === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = configureStore.store?.getState()?.auth?.refreshToken;
      const access_token = await refresh_token(refreshToken);
      configureStore.store.dispatch(
        setRefreshedTokenData(access_token.data.body)
      );
      axios.defaults.headers.common["Authorization"] =
        access_token.data.body.access_token;
      return student(originalRequest);
    }
    return response;
  },
  async function (error) {
    return Promise.reject(error);
  }
);

staff.interceptors.response.use(
  async (response) => {
    const originalRequest = response.config;

    if (response.data.statusCodeValue === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = configureStore.store?.getState()?.auth?.refreshToken;
      const access_token = await refresh_token(refreshToken);
      configureStore.store.dispatch(
        setRefreshedTokenData(access_token.data.body)
      );
      axios.defaults.headers.common["Authorization"] =
        access_token.data.body.access_token;
      return staff(originalRequest);
    }
    return response;
  },
  async function (error) {
    return Promise.reject(error);
  }
);

course.interceptors.response.use(
  async (response) => {
    const originalRequest = response.config;

    if (response.data.statusCodeValue === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = configureStore.store?.getState()?.auth?.refreshToken;
      const access_token = await refresh_token(refreshToken);
      configureStore.store.dispatch(
        setRefreshedTokenData(access_token.data.body)
      );
      axios.defaults.headers.common["Authorization"] =
        access_token.data.body.access_token;
      return course(originalRequest);
    }
    return response;
  },
  async function (error) {
    return Promise.reject(error);
  }
);

semester.interceptors.response.use(
  async (response) => {
    const originalRequest = response.config;

    if (response.data.statusCodeValue === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = configureStore.store?.getState()?.auth?.refreshToken;
      const access_token = await refresh_token(refreshToken);
      configureStore.store.dispatch(
        setRefreshedTokenData(access_token.data.body)
      );
      axios.defaults.headers.common["Authorization"] =
        access_token.data.body.access_token;
      return semester(originalRequest);
    }
    return response;
  },
  async function (error) {
    return Promise.reject(error);
  }
);

subject.interceptors.response.use(
  async (response) => {
    const originalRequest = response.config;

    if (response.data.statusCodeValue === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = configureStore.store?.getState()?.auth?.refreshToken;
      const access_token = await refresh_token(refreshToken);
      configureStore.store.dispatch(
        setRefreshedTokenData(access_token.data.body)
      );
      axios.defaults.headers.common["Authorization"] =
        access_token.data.body.access_token;
      return subject(originalRequest);
    }
    return response;
  },
  async function (error) {
    return Promise.reject(error);
  }
);

circular.interceptors.response.use(
  async (response) => {
    const originalRequest = response.config;

    if (response.data.statusCodeValue === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = configureStore.store?.getState()?.auth?.refreshToken;
      const access_token = await refresh_token(refreshToken);
      configureStore.store.dispatch(
        setRefreshedTokenData(access_token.data.body)
      );
      axios.defaults.headers.common["Authorization"] =
        access_token.data.body.access_token;
      return circular(originalRequest);
    }
    return response;
  },
  async function (error) {
    return Promise.reject(error);
  }
);

dashboard.interceptors.response.use(
  async (response) => {
    const originalRequest = response.config;

    if (response.data.statusCodeValue === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = configureStore.store?.getState()?.auth?.refreshToken;
      const access_token = await refresh_token(refreshToken);
      configureStore.store.dispatch(
        setRefreshedTokenData(access_token.data.body)
      );
      axios.defaults.headers.common["Authorization"] =
        access_token.data.body.access_token;
      return circular(originalRequest);
    }
    return response;
  },
  async function (error) {
    return Promise.reject(error);
  }
);

attendance.interceptors.response.use(
  async (response) => {
    const originalRequest = response.config;

    if (response.data.statusCodeValue === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = configureStore.store?.getState()?.auth?.refreshToken;
      const access_token = await refresh_token(refreshToken);
      configureStore.store.dispatch(
        setRefreshedTokenData(access_token.data.body)
      );
      axios.defaults.headers.common["Authorization"] =
        access_token.data.body.access_token;
      return attendance(originalRequest);
    }
    return response;
  },
  async function (error) {
    return Promise.reject(error);
  }
);

examAndGrade.interceptors.response.use(
  async (response) => {
    const originalRequest = response.config;

    if (response.data.statusCodeValue === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = configureStore.store?.getState()?.auth?.refreshToken;
      const access_token = await refresh_token(refreshToken);
      configureStore.store.dispatch(
        setRefreshedTokenData(access_token.data.body)
      );
      axios.defaults.headers.common["Authorization"] =
        access_token.data.body.access_token;
      return examAndGrade(originalRequest);
    }
    return response;
  },
  async function (error) {
    return Promise.reject(error);
  }
);

staffAttendance.interceptors.response.use(
  async (response) => {
    const originalRequest = response.config;

    if (response.data.statusCodeValue === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = configureStore.store?.getState()?.auth?.refreshToken;
      const access_token = await refresh_token(refreshToken);
      configureStore.store.dispatch(
        setRefreshedTokenData(access_token.data.body)
      );
      axios.defaults.headers.common["Authorization"] =
        access_token.data.body.access_token;
      return staffAttendance(originalRequest);
    }
    return response;
  },
  async function (error) {
    return Promise.reject(error);
  }
);

classes.interceptors.response.use(
  async (response) => {
    const originalRequest = response.config;

    if (response.data.statusCodeValue === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = configureStore.store?.getState()?.auth?.refreshToken;
      const access_token = await refresh_token(refreshToken);
      configureStore.store.dispatch(
        setRefreshedTokenData(access_token.data.body)
      );
      axios.defaults.headers.common["Authorization"] =
        access_token.data.body.access_token;
      return classes(originalRequest);
    }
    return response;
  },
  async function (error) {
    return Promise.reject(error);
  }
);

lend.interceptors.response.use(
  async (response) => {
    const originalRequest = response.config;

    if (response.data.statusCodeValue === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = configureStore.store?.getState()?.auth?.refreshToken;
      const access_token = await refresh_token(refreshToken);
      configureStore.store.dispatch(
        setRefreshedTokenData(access_token.data.body)
      );
      axios.defaults.headers.common["Authorization"] =
        access_token.data.body.access_token;
      return lend(originalRequest);
    }
    return response;
  },
  async function (error) {
    return Promise.reject(error);
  }
);

arrival.interceptors.response.use(
  async (response) => {
    const originalRequest = response.config;

    if (response.data.statusCodeValue === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = configureStore.store?.getState()?.auth?.refreshToken;
      const access_token = await refresh_token(refreshToken);
      configureStore.store.dispatch(
        setRefreshedTokenData(access_token.data.body)
      );
      axios.defaults.headers.common["Authorization"] =
        access_token.data.body.access_token;
      return arrival(originalRequest);
    }
    return response;
  },
  async function (error) {
    return Promise.reject(error);
  }
);

institution.interceptors.response.use(
  async (response) => {
    const originalRequest = response.config;

    if (response.data.statusCodeValue === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = configureStore.store?.getState()?.auth?.refreshToken;
      const access_token = await refresh_token(refreshToken);
      configureStore.store.dispatch(
        setRefreshedTokenData(access_token.data.body)
      );
      axios.defaults.headers.common["Authorization"] =
        access_token.data.body.access_token;
      return arrival(originalRequest);
    }
    return response;
  },
  async function (error) {
    return Promise.reject(error);
  }
);
export {
  client,
  student,
  course,
  semester,
  subject,
  circular,
  dashboard,
  attendance,
  staff,
  lend,
  arrival,
  examAndGrade,
  staffAttendance,
  classes,
  institution
};
